import { useEffect } from "react";
import Dashleft from "../Dashleft/Dashleft";
import Dashright from "../Dashright/Dashright";

import { careerWheelData, jobLevelCycle } from "../../atoms/dashboard";
import { useRecoilValue } from "recoil";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
import { jobRole5 } from "../../components/JobLevel/jobRole5";
import Slideover from "../../components/slideover/slideover";
import { milestoneSampleData } from "../../utils/milestonedata";
import Stepper from "../../components/stepper/stepper";
import Tab from "../../components/tab/tab";
import { myCareerWheel } from "../../selectors/dashboard";
import { milestoneDetails } from "../../selectors/dashboard";
import { MycarUrl } from "../../selectors/baseurl";
const Main = () => {
  const roleInfoData = useRecoilValue(jobLevelCycle);
   const careerWheelApiData = useRecoilValue(myCareerWheel);
  //const careerWheelApiData = jobRole5;
  const milestone = useRecoilValue(milestoneDetails);

  console.log('careerWeelApiData', careerWheelApiData)
 
  useEffect(() => {
   
    console.log("main screen executed");
    let bindAll = function () {
      let tabLink = document.getElementsByClassName("my-tabs");
      let tabMenus = tabLink[0]?.querySelectorAll("button");
      let tabContent = document.getElementsByClassName("tab-content");
      for (let i = 0; i < tabMenus?.length; i++) {
        tabMenus[i].addEventListener("click", change, false);
        if (i == 0) {
          tabMenus[i].classList.add("active");
          tabContent[0].childNodes[i].classList.add("active");
        }
      }


      let tabLink1 = document?.getElementsByClassName("tab-role");
      let tabMenus1 = tabLink1[0]?.querySelectorAll("button");
      let tabContent1 = document.getElementsByClassName("my-role-content");
      for (let i = 0; i < tabMenus1?.length; i++) {
        tabMenus1[i].addEventListener("click", innerchange, false);
        if (i == 0) {
          tabMenus1[i].querySelector('.role-span').classList.add('active')
          tabMenus1[i].classList.add("active");
          tabContent1[0].childNodes[i].classList.add("active");
        }
      }
    };

    let clear = function () {
      let tabLink = document.getElementsByClassName("my-tabs");
      let tabMenus = tabLink[0].querySelectorAll("button");
      let tabContent = document.getElementsByClassName("tab-content");
      let tabContInner = tabContent[0].childNodes;

      for (let i = 0; i < tabMenus?.length; i++) {
        tabMenus[i].classList.remove("active");
        tabContInner[i].classList.remove("active");
      }
    };

    let innerClear = function () {
      let tabLink1 = document.getElementsByClassName("tab-role");
      let tabMenus1 = tabLink1[0].querySelectorAll("button");
      let tabContent1 = document.getElementsByClassName("my-role-content");
      let tabContInner1 = tabContent1[0].childNodes;

      for (let i = 0; i < tabMenus1?.length; i++) {
        tabMenus1[i].querySelector('.role-span').classList.remove('active')
        tabMenus1[i].classList.remove("active");
        tabContInner1[i].classList.remove("active");
      }
    };

    function getElementIndex(el) {
      return [...el.parentElement.children].indexOf(el);
    }

    const change = function (e) {
      clear();
      let getIdx = getElementIndex(e.target.closest("button"));
      let tabLink = document.getElementsByClassName("my-tabs");
      let tabMenus = tabLink[0].querySelectorAll("button");
      let tabContent = document.getElementsByClassName("tab-content");
      let tabContInner = tabContent[0].childNodes;
      tabMenus[getIdx].classList.add("active");
      tabContInner[getIdx].classList.add("active");
    };

    const innerchange = function (e) {
      innerClear();
      let getIdx = getElementIndex(e.target.closest("button"));
      let tabLink = document.getElementsByClassName("tab-role");
      let tabMenus = tabLink[0].querySelectorAll("button");
      let tabContent = document.getElementsByClassName("my-role-content");
      let tabContInner = tabContent[0].childNodes;
      tabMenus[getIdx].querySelector('.role-span').classList.add('active')
      tabMenus[getIdx].classList.add("active");
      tabContInner[getIdx].classList.add("active");
    };

    bindAll();

    const specifiedElement =
      document.getElementById("noti-dropdown") ||
      document.getElementById("help-dropdown") ||
      document.getElementById("settings-dropdown");


    document.addEventListener("click", (event) => {
      const isClickInside = specifiedElement?.contains(event.target);
      if (
        event.target.closest("button")?.id == "notification-icon" ||
        event.target.closest("button")?.id == "help-icon" ||
        event.target.closest("button")?.id == "more-icon" ||
        event.target.closest("button")?.id == "acc-icon"
      )
        return;
      if (!isClickInside) {
        let dropdown = document.querySelectorAll(".dropdown");
        for (let i = 0; i < dropdown?.length; ++i) {
          dropdown[i].classList.add("hidden");
        }
      }
    });
  }, [roleInfoData]);

  function Myjourney() {
    return (
      <div className="flow-root p-3 mt-3">
        {milestone && <Stepper data={milestone} />}
      </div>
    );
  }

  const tabData = {
    title: ["My Journey"],
    icon: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="12.034" height="11.143" viewBox="0 0 12.034 11.143"><path data-name="Icon metro-suitcase" d="M15.641 16.927H5.39a.891.891 0 0 1-.891-.891v-5.349a22.7 22.7 0 0 0 4.457 1.687v.542a.445.445 0 0 0 .446.446h2.228a.446.446 0 0 0 .446-.446v-.542a22.709 22.709 0 0 0 4.457-1.687v5.348a.892.892 0 0 1-.892.892zm-4.457-5.348a.446.446 0 0 1 .446.446v.446a.446.446 0 0 1-.446.446H9.847a.445.445 0 0 1-.447-.447v-.446a.445.445 0 0 1 .446-.446zm.891 0a.446.446 0 0 0-.446-.446H9.4a.445.445 0 0 0-.446.446v.4A22.325 22.325 0 0 1 4.5 10.241V8.458a.891.891 0 0 1 .891-.891h2.673v-.891a.892.892 0 0 1 .891-.891h3.12a.892.892 0 0 1 .891.891v.891h2.674a.892.892 0 0 1 .891.891v1.783a22.338 22.338 0 0 1-4.457 1.736zm0-4.457a.446.446 0 0 0-.446-.446H9.4a.445.445 0 0 0-.446.446v.446h3.12z" transform="translate(-4.499 -5.784)"></path></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="11.768" height="11.271" viewBox="0 0 11.768 11.271"><path data-name="Icon material-flag" d="M14.874 7.326 14.561 6H7.5v11.271h1.569V12.63h4.393l.314 1.326h5.492v-6.63z" transform="translate(-7.5 -6)"></path></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="14.277" height="9.994" viewBox="0 0 14.277 9.994"><path data-name="Icon awesome-users" d="M2.142 6.533A1.428 1.428 0 1 0 .714 5.105a1.429 1.429 0 0 0 1.428 1.428zm9.994 0a1.428 1.428 0 1 0-1.428-1.428 1.429 1.429 0 0 0 1.428 1.428zm.714.714h-1.428a1.424 1.424 0 0 0-1.006.415 3.263 3.263 0 0 1 1.675 2.438h1.472a.713.713 0 0 0 .714-.714v-.711a1.429 1.429 0 0 0-1.427-1.428zm-5.711 0a2.5 2.5 0 1 0-2.5-2.5 2.5 2.5 0 0 0 2.5 2.5zm1.713.714h-.185a3.45 3.45 0 0 1-3.056 0h-.186a2.571 2.571 0 0 0-2.57 2.57v.642a1.071 1.071 0 0 0 1.071 1.071h6.425a1.071 1.071 0 0 0 1.071-1.071v-.642a2.571 2.571 0 0 0-2.57-2.57zm-4.99-.3a1.424 1.424 0 0 0-1.006-.415H1.428A1.429 1.429 0 0 0 0 8.675v.714a.713.713 0 0 0 .714.714h1.47a3.271 3.271 0 0 1 1.678-2.441z" transform="translate(0 -2.25)"></path></svg>',
    ],
    content: [<Myjourney />],
    parentClassName: "",
    menuClassName: "my-tabs",
    contentParentClassName: "tab-content",
    contentClassName: ["my-journey"],
  };


  return (
    <>
      <div className="flex h-full dashboard p-4">
        <div className="w-1/4 pr-4 py-2 overflow-y-auto bg-white dashleft">
          <Dashleft />
        </div> 
        {careerWheelApiData?.length > 0 && careerWheelApiData !='No record found' ? <div className="w-3/4 px-4 py-2 right-panel">
          <Dashright details={roleInfoData} />
        </div> : <div className="w-3/4 right-panel">
          <NoDataFound tabData={tabData} />
        </div>}
      </div>
    </>
  );
};

export default Main;

